<template lang="pug">
v-container.px-xs-0.pb-16.px-lg-16(:style="containerStyles")
  v-row.pa-sm-2(align="center")
    v-col.pa-0.d-flex.justify-center.align-center(cols="3", sm="1")
      div(:style="headerIconStyles")
        v-icon(:size="30", color="primary") 
          slot(name="icon") {{ calenderIcon }}
    v-col(cols="9", sm="11")
      Header(:text="formTitle", customClass="mt-0 pl-sm-2")
  v-row.mt-4.mt-sm-8.pa-sm-4(
    align-content="stretch",
    align="stretch",
    justify="end"
  )
    v-col.pa-sm-4.d-flex.justify-center.align-stretch(
      cols="12",
      lg="5",
      sm="6",
      :style="formActionsStyles"
    )
      slot(name="headerActions") 
    v-col.pa-sm-0.pr-sm-4(cols="12", lg="7", sm="6", order="sm-first")
      slot(name="headerAlert") 

  v-row
    v-col.d-flex.justify-end.mt-4.pb-0(cols="12")
      TextBody(:text="fieldsText", :fontSize="0.8", customClass="mb-0")
    v-col(cols="12") 
      slot(name="main")
  v-row.mt-4.mt-sm-8.pa-sm-4(
    align-content="stretch",
    align="stretch",
    justify="end"
  )
    v-col.pa-sm-0.pr-sm-4(cols="12", lg="7", sm="6")
      slot(name="footerAlert") 
    v-col.pa-sm-4.d-flex.justify-center.align-stretch(
      cols="12",
      lg="5",
      sm="6",
      :style="formActionsStyles"
    )
      slot(name="footerActions") 
</template>

<script lang="ts">
import Vue from "vue"
import Header from "./Header.vue"
import TextBody from "./TextBody.vue"
import { mdiCalendarRange } from "@mdi/js"

export default Vue.extend({
  name: "FormLayout",
  components: {
    Header,
    TextBody,
  },
  props: {
    formTitle: { type: String, required: true },
    fieldsText: { type: String, default: `* Pflichtfelder` },
  },
  data: () => ({
    calenderIcon: mdiCalendarRange,
  }),
  computed: {
    headerIconStyles(): object {
      return {
        border: `2px solid ${this.$vuetify.theme.themes.light.primary}`,
        borderRadius: `4px`,
        width: "50px",
        height: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }
    },
    containerStyles(): object {
      return { maxWidth: "960px" }
    },
    formActionsStyles(): object {
      return {
        backgroundColor: `${this.$vuetify.theme.themes.light.lightGrey} !important`,
        borderRadius: "4px",
        height: "100%",
      }
    },
  },
})
</script>
